import React, { useState } from "react";
import {
  Box,
  MenuItem,
  Modal,
  Typography,
  Select,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import axios from "axios";
import api , { API_BASE_URL } from "../../src/utils/api";
import AutorenewIcon from "@mui/icons-material/Autorenew";



const EditViolation = ({ violationDetails, onUpdate }) => {
  const [anchorEl, setAnchorEl] = useState(null); // Anchor for the three dots menu
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Modal open state
  const [updatedStatus, setUpdatedStatus] = useState(
    violationDetails.status || "Open" // Set initial status
  );
  const [isSaving, setIsSaving] = useState(false); // Loading state for saving changes

  // Get currentUserId from localStorage
  const currentUserId = localStorage.getItem("currentUserId");

  // Handle opening the menu
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle closing the menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Handle opening the edit modal
  const handleEditModalOpen = () => {
    setIsEditModalOpen(true);
    handleMenuClose();
  };

  // Handle closing the edit modal
  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
  };

  // Save changes and make the API call
  const handleSaveChanges = async () => {
    const updatedData = {
      resolved_by: updatedStatus === "Closed" ? currentUserId : null,
      status: updatedStatus,
    };
  
    console.log("Payload being sent to API:", updatedData); // Log the payload
  
    try {
      setIsSaving(true);
  
      // Ensure violation_id is included in the API URL
      await api.put(
        `/editViolationstatus/${violationDetails.id}`,
        updatedData
      );
  
      onUpdate(updatedData);
      alert("Violation status updated successfully!");
      handleEditModalClose();
    } catch (error) {
      console.error("Error updating violation:", error);
      alert("Failed to update violation. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };
  

  return (
    <Box>
      {/* Three dots menu for editing */}
      <Button
  variant="contained"
  onClick={handleEditModalOpen}
  startIcon={<AutorenewIcon />}
  sx={{
    textTransform: "none",
    fontWeight: 500,
    fontSize: "14px",
    borderRadius: "20px",
    px: 3,
    py: 1,
    backgroundColor: "#1976d2",
    color: "#ffffff",
    boxShadow: "0px 2px 6px rgba(25, 118, 210, 0.1)",
    "&:hover": {
      backgroundColor: "#63a4ff",
    },
     top: 8,
    right: 8, // Keeps same placement as the 3 dots
  }}
>
  Change Status
</Button>


      {/* Modal for editing the status */}
      <Modal open={isEditModalOpen} onClose={handleEditModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            backgroundColor: "white",
            padding: 4,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Edit Violation Status
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={updatedStatus}
              onChange={(e) => setUpdatedStatus(e.target.value)}
            >
              <MenuItem value="Open">Open</MenuItem>
              <MenuItem value="Closed">Closed</MenuItem>
              <MenuItem value="Regression">Regression</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveChanges}
            fullWidth
            disabled={isSaving} // Disable the button while saving
          >
            {isSaving ? "Saving..." : "Save Changes"}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default EditViolation;
